import classNames from 'classnames'
import React from 'react'
import { PortableTextBodyElement } from '../../utilities/blockContent'
import { IS_EQT_FUNDS } from '../../utilities/site'
import {
  isNullOrWhiteSpace,
  sanitizeHtmlAndReplaceNewlines,
} from '../../utilities/string'
import { Grid } from '../Grid'
import { RichTextArea } from '../PortableText/RichTextArea'
import { TwoColumnTextBlockSerializer } from '../PortableText/serializers/blocks/TwoColumnTextBlockSerializer'
import { TwoColumnTextListSerializer } from '../PortableText/serializers/lists/TwoColumnTextListSerializer'

export interface TwoColumnTextProps {
  blockContent?: JSX.Element
  preamble?: string
  preambleFormatted?: PortableTextBodyElement[]
  preambleAsBody?: boolean
  title?: string
}

export const TwoColumnText = ({
  blockContent,
  preamble,
  preambleFormatted,
  preambleAsBody,
  title,
}: TwoColumnTextProps) => (
  <Grid>
    <div
      className={classNames(
        'col-span-full flex flex-col',
        'tb:col-start-1 tb:col-span-2 tb:ml-30',
        'sm:col-start-2 sm:col-span-2 sm:ml-0',
        'md:col-start-1 md:col-span-2',
        'lg:col-start-2',
        { 'lg:col-span-2': !IS_EQT_FUNDS, 'lg:col-span-3 lg:ml-75': IS_EQT_FUNDS },
        'xxl:col-start-3',
        { 'xxl:col-span-2': !IS_EQT_FUNDS, 'xxl:col-span-3': IS_EQT_FUNDS }
      )}
    >
      {!isNullOrWhiteSpace(title) && (
        <h2
          className={classNames(
            'mb-15 font-h2 text-h2 text-secondary-darker',
            'lg:mb-30 lg:-mr-90'
          )}
        >
          {title}
        </h2>
      )}
      {!!preambleFormatted?.length && (
        <div
          className={classNames(
            'text-secondary-darkest mb-30 tb:mb-0',
            { 'font-preamble text-preamble': !preambleAsBody },
            { 'font-body text-body': !!preambleAsBody }
          )}
        >
          <RichTextArea
            components={{
              block: TwoColumnTextBlockSerializer,
              list: TwoColumnTextListSerializer,
            }}
            value={preambleFormatted}
          />
        </div>
      )}
      {!preambleFormatted?.length && !isNullOrWhiteSpace(preamble) && (
        <p
          className={classNames(
            'mb-30 text-secondary-darker',
            'tb:mb-0',
            { 'font-preamble text-preamble': !preambleAsBody },
            { 'font-body text-body': !!preambleAsBody }
          )}
          dangerouslySetInnerHTML={{
            __html: sanitizeHtmlAndReplaceNewlines(preamble),
          }}
        />
      )}
    </div>

    {blockContent && (
      <div
        className={classNames(
          'col-span-full',
          'tb:col-start-3 tb:col-span-2',
          'sm:col-start-4 sm:col-span-2',
          'md:col-start-4 md:col-span-3 md:mr-60',
          'lg:col-start-5 lg:col-span-3',
          { 'lg:mr-75': IS_EQT_FUNDS, 'xl:mr-0': !IS_EQT_FUNDS },
          'xl:col-start-6 xl:col-span-3',
          'xxl:col-start-8 xxl:col-span-3'
        )}
      >
        {blockContent}
      </div>
    )}
  </Grid>
)
